import { UPDATE_ME, UPDATE_ME_ERROR } from "../types";

export const updateMeReducer = (state = {}, action) => {
  switch (action.type) {
    case UPDATE_ME:
      return { ...state, updateMe: action.payload };
    case UPDATE_ME_ERROR:
      return { ...state, updateMeError: action.payload.message };
    default:
      return state;
  }
};
